"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = exports.Column = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
function Column(_a) {
  var _b = _a.children,
    children = _b === void 0 ? null : _b,
    _c = _a.span,
    span = _c === void 0 ? 1 : _c,
    _d = _a.justifyContent,
    justifyContent = _d === void 0 ? null : _d,
    _e = _a.justifySelf,
    justifySelf = _e === void 0 ? null : _e,
    _f = _a.textAlign,
    textAlign = _f === void 0 ? null : _f,
    _g = _a.alignItems,
    alignItems = _g === void 0 ? null : _g,
    _h = _a.alignSelf,
    alignSelf = _h === void 0 ? null : _h,
    _j = _a.fullWidth,
    fullWidth = _j === void 0 ? false : _j,
    _k = _a.position,
    position = _k === void 0 ? null : _k,
    _l = _a.flex,
    flex = _l === void 0 ? false : _l,
    _m = _a.sx,
    sx = _m === void 0 ? {} : _m;
  return react_1.default.createElement(rebass_1.Box, {
    sx: __assign({
      display: flex ? "flex" : "block",
      textAlign: textAlign,
      justifyContent: justifyContent,
      justifySelf: justifySelf,
      alignItems: alignItems,
      alignSelf: alignSelf,
      position: position,
      gridColumn: Array.isArray(span) ? span.map(function (responsiveSpan) {
        return "auto / span " + (fullWidth ? 12 : responsiveSpan);
      }) : "auto / span " + (fullWidth ? 12 : span)
    }, sx)
  }, children);
}
exports.Column = Column;
function Grid(_a) {
  var _b = _a.children,
    children = _b === void 0 ? null : _b,
    _c = _a.limitWidth,
    limitWidth = _c === void 0 ? true : _c;
  return react_1.default.createElement(rebass_1.Box, {
    sx: {
      maxWidth: limitWidth ? [720, 960, 1280] : null,
      mx: "auto",
      width: "100%",
      display: "grid",
      gridGap: "20px",
      px: 4,
      py: 4,
      alignItems: "center",
      gridTemplateColumns: ["repeat(4, 1fr)", "repeat(12, 1fr)", "repeat(12, 1fr)"]
    }
  }, children);
}
exports.Grid = Grid;